module.exports = __webpack_public_path__ + "static/media/toll.c31c3c10.mp3";